import { Directive, Host, ElementRef } from '@angular/core';
import { MatExpansionPanel } from '@angular/material/expansion';

import { merge } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Preferences } from '@library/core/services';

import { ShipmentComponentsService } from './shipment.components.service';

@Directive({
   selector: 'mat-expansion-panel'
})
export class ExpandedDirective {

   id: string;

   constructor(
      @Host() private panel: MatExpansionPanel,
      private el: ElementRef,
      private components: ShipmentComponentsService,
      private prefs: Preferences,
   ) {
      this.panel.expanded = true;

      setTimeout( _ => {
         this.id = this.el.nativeElement.id;

         if ( this.id ) {
            const pref = this.prefs.getPref( 'booking' )?.expanded?.[this.id];

            const prop = this.components.shipmentComponents$.getValue().find( c => c.id === this.id );
            if ( pref || prop ) {
               this.panel.expanded = pref ?? prop?.expanded;
            }
         }

         // update prefs if the panel changes
         merge(
            this.panel.opened,
            this.panel.closed,
         ).pipe( takeUntil( this.panel.destroyed )).subscribe( _ =>
            this.prefs.upsertPref( 'booking.expanded', {[ this.id ]: this.panel.expanded }));
      });
   }
}
